<div class="export-result">

	<div class="export-result__badge" aria-hidden="true">
		<i class="mdi mdi-check"></i>
	</div>

	<h1 *ngIf="data?.title" class="export-result__title" mat-dialog-title>{{ data.title }}</h1>

	<div class="export-result__body" mat-dialog-content>
		<p *ngIf="data.message" class="export-result__message">{{ data.message }}</p>

		<div *ngIf="data.filename" class="export-result__file">
			<i class="mdi mdi-file-excel-outline export-result__file-icon" aria-hidden="true"></i>
			<span class="export-result__file-name" [title]="data.filename">{{ data.filename }}</span>
		</div>

		<div *ngIf="data.downloadsHint" class="export-result__hint">
			<i class="mdi mdi-folder-download-outline" aria-hidden="true"></i>
			<span>{{ data.downloadsHint }}</span>
		</div>
	</div>

	<div class="export-result__actions" mat-dialog-actions>
		<button *ngIf="data.fileUrl"
				class="btn btn--quaternary btn-md"
				(click)="openFile()">
			{{ data.openLabel | capitalize }}
		</button>
		<button class="btn btn--primary btn-md export-result__close"
				(click)="close()"
				cdkFocusInitial>
			{{ data.closeLabel | capitalize }}
		</button>
	</div>
</div>
